// Toggle a class on the sticky header once the user scrolls past the
// top so we can drop a subtle shadow when the bar is no longer flush.
const SCROLL_THRESHOLD = 8;

export default function stickyHeader() {
    const header = document.querySelector('[data-sticky-header]');

    if (!header) {
        return;
    }

    let ticking = false;

    const update = () => {
        const scrolled = window.scrollY > SCROLL_THRESHOLD;
        header.classList.toggle('is-scrolled', scrolled);
        ticking = false;
    };

    window.addEventListener(
        'scroll',
        () => {
            if (!ticking) {
                window.requestAnimationFrame(update);
                ticking = true;
            }
        },
        { passive: true },
    );

    update();
}
